export default __webpack_public_path__ + "static/media/error-404.53a8768d.svg";